<template>
    <div class="h-toolbarBg">
        <ejs-toolbar ref="toolBarForCounterList">
            <e-items>
                <e-item prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("Pm.thresholdSetting")' :click="customCounterButtonClick" operate='create'></e-item>
                <e-item prefixIcon='icon hero-icon hero-icon-start-up' :tooltipText='$t("Pm.activeThreshold")' :click="customCounterButtonClick" operate='active'></e-item>
                <e-item prefixIcon='icon hero-icon hero-icon-disable' :tooltipText='$t("Pm.hangupThreshold")' :click="customCounterButtonClick" operate='hangup'></e-item>
                <e-item prefixIcon='icon hero-icon hero-icon-details' :tooltipText='$t("Pm.thresholdDetail")' :click="customCounterButtonClick" operate='detail'></e-item>
            </e-items>
        </ejs-toolbar>
        <div class='h-inputBox'>
            <ejs-textbox v-model='counterName' :placeholder='$t("Pm.counterName")' @keyup.enter.native="searchByCounterName" maxLength='20'></ejs-textbox>
        </div>
    </div>
</template>

<script>

    import {PmEventBus} from "../../../util/PmEventBus"

    export default {
        name: "CounterListToolBar",
        props: [
            'taskStatus'
        ],
        data() {
            return{
                counterName: ""
            }
        },
        methods: {
            customCounterButtonClick(args){
                this.$parent.methodList(args.item.operate);
            },
            searchByCounterName(){
                this.$parent.searchByCounterName(this.counterName);
            },
        },
        watch: {
            taskStatus(taskStatus){
                // 0 门限设置 1 门限激活 2 门限挂起 3 门限详情
                switch (taskStatus) {
                    case '0': // 挂起
                        this.$refs.toolBarForCounterList.enableItems([0, 1, 3], true);
                        this.$refs.toolBarForCounterList.enableItems([2], false);
                        break;
                    case '1': // 激活
                        this.$refs.toolBarForCounterList.enableItems([0, 2, 3], true);
                        this.$refs.toolBarForCounterList.enableItems([1], false);
                        break;
                    default:
                        this.$refs.toolBarForCounterList.enableItems([0], true);
                        this.$refs.toolBarForCounterList.enableItems([1, 2, 3], false);
                        break;
                }
            }
        },
        mounted() {
            this.$refs.toolBarForCounterList.enableItems([0], true);
            this.$refs.toolBarForCounterList.enableItems([1, 2, 3], false);
        }
    }
</script>

<style scoped>

</style>
